import type { QuickSwitcherHandlerResponseBody } from '@ps/isp-web-services-types';
import { FeatureFlag } from '@ps/web-core-enums';
import { canUseDOM } from '@ps/web-core-utils';

import type { EffectParams } from '@swf/core/store';
import buildSportsRequest from '@swf/sports/utils/buildSportsRequest';

import type { HierarchyLevel } from './types';

export const effects = {
  async quickSwitcherRequested(
    { hierarchyLevel, facetId }: { hierarchyLevel: HierarchyLevel; facetId: string },
    { request, rootState, dispatch, select }: EffectParams
  ) {
    const isQuickSwitcherEnabled = select.feature.check(rootState, FeatureFlag.ISPQuickSwitcher);

    if (!canUseDOM || !isQuickSwitcherEnabled) return;

    dispatch.quickSwitcher.loading();

    const sportsRequest = buildSportsRequest(request, rootState);

    try {
      const { body } = await sportsRequest<QuickSwitcherHandlerResponseBody>({
        path: `/quick-switcher/${hierarchyLevel}/${facetId}`
      });

      dispatch.quickSwitcher.dataLoadSuccess(body);
    } catch {
      dispatch.quickSwitcher.loading(false);
    }
  }
};
